
        // classnames-loader: automatically bind css-modules to classnames
        var classNames = require("!../../node_modules/classnames/bind.js");
        var locals = require("!!../../node_modules/style-loader/index.js!../../node_modules/css-loader/dist/cjs.js??ref--5-2!../../node_modules/postcss-loader/src/index.js??ref--5-3!../../node_modules/sass-loader/lib/loader.js!./global.scss");
        var css = classNames.bind(locals);
        for (var style in locals) css[style] = locals[style];
        module.exports = css;
    